import styled from 'styled-components';

export const MapQuickAccessMobileCustomContainer = styled.div`
    display: block;
`;
